import { render, staticRenderFns } from "./ExpenseSpaceSettings.vue?vue&type=template&id=1f0ddc32&scoped=true&"
import script from "./ExpenseSpaceSettings.vue?vue&type=script&lang=js&"
export * from "./ExpenseSpaceSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseSpaceSettings.vue?vue&type=style&index=0&id=1f0ddc32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ddc32",
  null
  
)

export default component.exports